import React, { Component } from 'react';
import Index from '../components/settings/Icons/Index'
import WebpackerReact from 'webpacker-react';


class IndexIcon extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = icon => {
        this.setState({
            data: this.state.data.map(item => {
            if (icon.id === item.id) {
              return { ...item, 
                name: icon.name,
                html_name: icon.html_name,
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(`/settings/get_icons`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Index
                    data={this.state.data}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    loadData={this.loadData}
                />
            </React.Fragment>
        );
    }
}


export default IndexIcon;
WebpackerReact.setup({ IndexIcon });


